// Calcula segundos uteis (dentro da janela de atendimento configurada)
// entre dois instantes. Espelha a logica do backend em
// metricas/services/atendimentoMetricasService.js (`tempoEmJanela`), mas
// trabalha em milissegundos/segundos para alimentar o cronometro ao vivo
// na tela de Atendimentos.
//
// horariosPorDia: array com 7 itens vindos de siti_atendimento_horario
//   [{ dia_semana: 0..6, ativo: 0|1, inicio: 'HH:mm', fim: 'HH:mm' }, ...]
// horarioAtivo: boolean - quando false, atende 24/7 (tempo corrido).
// Sem horarios configurados: cai pra tempo corrido.

function parseHHmm(txt) {
  const m = String(txt || '').match(/^(\d{1,2}):(\d{1,2})$/);
  if (!m) return null;
  return { h: Number(m[1]), m: Number(m[2]) };
}

export function segundosEmJanela(inicio, fim, horariosPorDia, horarioAtivo) {
  if (!inicio || !fim) return null;
  const ini = inicio instanceof Date ? new Date(inicio) : new Date(inicio);
  const end = fim instanceof Date ? new Date(fim) : new Date(fim);
  if (Number.isNaN(ini.getTime()) || Number.isNaN(end.getTime())) return null;
  if (end <= ini) return 0;

  // Sem janela ativa = 24/7
  if (!horarioAtivo || !Array.isArray(horariosPorDia) || !horariosPorDia.length) {
    return Math.floor((end - ini) / 1000);
  }

  let segundos = 0;
  let cursor = new Date(ini);
  let safety = 0;
  while (cursor < end && safety < 400) {
    safety += 1;
    const dia = horariosPorDia.find((h) => Number(h.dia_semana) === cursor.getDay());
    const inicioDia = new Date(cursor);
    inicioDia.setHours(0, 0, 0, 0);
    const proximoDia = new Date(inicioDia);
    proximoDia.setDate(proximoDia.getDate() + 1);

    if (dia && Number(dia.ativo) === 1) {
      const ini0 = parseHHmm(dia.inicio) || { h: 8, m: 0 };
      const fim0 = parseHHmm(dia.fim) || { h: 18, m: 0 };
      const janelaIni = new Date(inicioDia);
      janelaIni.setHours(ini0.h, ini0.m, 0, 0);
      const janelaFim = new Date(inicioDia);
      janelaFim.setHours(fim0.h, fim0.m, 0, 0);

      const a = cursor > janelaIni ? cursor : janelaIni;
      const b = end < janelaFim ? end : janelaFim;
      if (b > a) {
        segundos += Math.floor((b - a) / 1000);
      }
    }

    cursor = proximoDia;
  }
  return segundos;
}

// Retorna true se "agora" cai dentro da janela do dia (usado pra decidir
// se o cronometro esta efetivamente correndo ou pausado).
export function dentroDaJanela(agora, horariosPorDia, horarioAtivo) {
  if (!horarioAtivo || !Array.isArray(horariosPorDia) || !horariosPorDia.length) {
    return true;
  }
  const dia = horariosPorDia.find((h) => Number(h.dia_semana) === agora.getDay());
  if (!dia || Number(dia.ativo) !== 1) return false;
  const ini0 = parseHHmm(dia.inicio) || { h: 8, m: 0 };
  const fim0 = parseHHmm(dia.fim) || { h: 18, m: 0 };
  const minutosAgora = agora.getHours() * 60 + agora.getMinutes();
  const ini = ini0.h * 60 + ini0.m;
  const fim = fim0.h * 60 + fim0.m;
  return minutosAgora >= ini && minutosAgora < fim;
}

// Formato adaptativo: cronometro humano pra TTFR.
//   < 60s   -> "00:SS"
//   < 60min -> "MM:SS"
//   >= 60m  -> "Hh MMm"
export function formatarCronometro(segundos) {
  if (segundos == null || Number.isNaN(segundos)) return '--:--';
  const s = Math.max(0, Math.floor(segundos));
  if (s < 3600) {
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return `${String(m).padStart(2, '0')}:${String(sec).padStart(2, '0')}`;
  }
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  return `${h}h ${String(m).padStart(2, '0')}m`;
}
